import site_init from './site_init';
document.addEventListener('DOMContentLoaded', () => {
    // In the event the CDN corp-nav script isn't accessible for any reason,
    // continue to run the rest of the page. (Should never happen)
    if (typeof window.renderNav !== 'function') {
        site_init();
    }
    else {
        window.renderNav({
            showLocationLookup: true,
        })
            .catch((err) => {
            console.error('RenderNav Error:', err);
        })
            .finally(() => {
            site_init();
        });
    }
});
